// document.addEventListener('DOMContentLoaded', () => {
//   const marquees = document.querySelectorAll('marquee-text');

//   marquees.forEach((marquee) => {
//     const speed = marquee.dataset.speed || 'medium';
//     const direction = marquee.dataset.direction || 'left';

//     // 控制速度：不同 speed 映射到不同 animation-duration
//     let duration;
//     switch (speed) {
//       case 'slow':
//         duration = '60s';
//         break;
//       case 'fast':
//         duration = '20s';
//         break;
//       case 'medium':
//       default:
//         duration = '40s';
//         break;
//     }

//     // 控制方向：left/right -> normal/reverse
//     const cssDirection = direction === 'right' ? 'reverse' : 'normal';

//     // 从 section 的 inline style 里拿到 gap 和 padding（如果你愿意，也可以直接用设置值）
//     const sectionId = marquee.closest('[id^="shopify-section-"]')?.id;
//     if (sectionId) {
//       const sectionEl = document.getElementById(sectionId);
//       if (sectionEl) {
//         const sectionSettingsEl = sectionEl.querySelector('.marquee-text-section');
//         if (sectionSettingsEl) {
//           // 这里假设你之后在 Liquid 里把 padding/gap 映射为 CSS 变量
//           const styles = getComputedStyle(sectionSettingsEl);

//           const gap = styles.getPropertyValue('--marquee-gap') || '24px';
//           const paddingTop = styles.getPropertyValue('--marquee-padding-block-start') || '24px';
//           const paddingBottom = styles.getPropertyValue('--marquee-padding-block-end') || '24px';

//           marquee.style.setProperty('--marquee-gap', gap.trim());
//           marquee.style.setProperty('--marquee-padding-block-start', paddingTop.trim());
//           marquee.style.setProperty('--marquee-padding-block-end', paddingBottom.trim());
//         }
//       }
//     }

//     marquee.style.setProperty('--marquee-duration', duration);
//     marquee.style.setProperty('--marquee-direction', cssDirection);
//   });
// });

document.addEventListener('DOMContentLoaded', () => {
  const marquees = document.querySelectorAll('marquee-text:not([data-disabled])');

  marquees.forEach((marquee) => {
    const speed = marquee.dataset.speed || 'medium';
    const direction = marquee.dataset.direction || 'left';

    // 1. 获取需要的元素
    const track = marquee.querySelector('.marquee-text__track');
    const originalItems = marquee.querySelector('.marquee-text__items:not(.marquee-text__items--clone)');
    const clonedItems = marquee.querySelector('.marquee-text__items--clone');
    
    if (!track || !originalItems || originalItems.children.length === 0) return;
    
    // 2. 计算需要多少副本（关键步骤）
    const calculateNumberOfCopies = () => {
      const marqueeWidth = marquee.offsetWidth;
      const firstItem = originalItems.firstElementChild;
      if (!firstItem) return 1;
      
      const itemWidth = firstItem.offsetWidth + parseInt(getComputedStyle(originalItems).gap || '24px');
      if (itemWidth === 0) return 1;
      
      // 计算需要多少份来填满容器，并额外添加1份确保无缝
      return Math.ceil(marqueeWidth / (originalItems.offsetWidth / originalItems.children.length)) + 1;
    };
    
    // 3. 创建无缝副本
    const createSeamlessCopies = () => {
      // 移除所有现有的克隆（除了第一个）
      const existingClones = marquee.querySelectorAll('.marquee-text__items--clone');
      existingClones.forEach((clone, index) => {
        if (index > 0) clone.remove();
      });
      
      // 计算需要的副本数量
      const numberOfCopies = calculateNumberOfCopies();
      
      // 创建额外副本
      for (let i = 1; i < numberOfCopies; i++) {
        const clone = originalItems.cloneNode(true);
        clone.classList.add('marquee-text__items--clone');
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      }
      
      return numberOfCopies;
    };
    
    // 4. 计算正确的动画时间
    const calculateAnimationDuration = () => {
      const speedMap = {
        'slow': 80,
        'medium': 40,
        'fast': 20,
        'ultra-slow': 120
      };
      
      let baseDuration = speedMap[speed] || 40;
      
      // 根据内容长度调整速度
      const numberOfCopies = createSeamlessCopies();
      
      // 设置CSS变量用于动画计算
      marquee.style.setProperty('--total-copies', numberOfCopies);
      
      return `${baseDuration}s`;
    };

    // 控制方向
    const cssDirection = direction === 'right' ? 'reverse' : 'normal';

    // 获取样式设置
    const gap = marquee.style.getPropertyValue('--marquee-gap') || '24px';
    const paddingTop = marquee.style.getPropertyValue('--marquee-padding-block-start') || '24px';
    const paddingBottom = marquee.style.getPropertyValue('--marquee-padding-block-end') || '24px';

    // 设置CSS变量
    const duration = calculateAnimationDuration();
    
    marquee.style.setProperty('--marquee-duration', duration);
    marquee.style.setProperty('--marquee-direction', cssDirection);
    marquee.style.setProperty('--marquee-gap', gap.trim());
    marquee.style.setProperty('--marquee-padding-block-start', paddingTop.trim());
    marquee.style.setProperty('--marquee-padding-block-end', paddingBottom.trim());
    
    // 5. 添加响应式处理
    let resizeTimeout;
    const handleResize = () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        const newDuration = calculateAnimationDuration();
        marquee.style.setProperty('--marquee-duration', newDuration);
        
        // 重启动画
        if (track.style.animationPlayState !== 'paused') {
          track.style.animation = 'none';
          setTimeout(() => {
            track.style.animation = '';
          }, 10);
        }
      }, 250);
    };
    
    window.addEventListener('resize', handleResize);
    
    // 6. 添加悬停效果
    marquee.addEventListener('mouseenter', () => {
      track.style.animationPlayState = 'paused';
    });
    
    marquee.addEventListener('mouseleave', () => {
      track.style.animationPlayState = 'running';
    });
    
    // 7. 清理函数
    marquee._cleanupMarquee = () => {
      window.removeEventListener('resize', handleResize);
    };
  });
});